import { StepTypes } from "@certa/studio-core/src/constants/step.constants.ts";
import { RuleType } from "@certa/studio-core/src/constants/rules.constants.ts";

export const READONLY_STEPTYPES = [StepTypes.FYI, StepTypes.READONLY];

export const basicStepTypeData: {
  [key in StepTypes]: {
    ruleTypeBlacklist: RuleType[];
  };
} = {
  [StepTypes.FYI]: {
    ruleTypeBlacklist: [RuleType.VersionNamingConstraints]
  },
  [StepTypes.READONLY]: {
    ruleTypeBlacklist: [RuleType.VersionNamingConstraints]
  },
  [StepTypes.INTERNAL]: {
    ruleTypeBlacklist: []
  },
  [StepTypes.NORMAL]: {
    ruleTypeBlacklist: []
  },
  [StepTypes.DOABLE]: {
    ruleTypeBlacklist: []
  }
};
